<section class="banner ">
  <div class="container mx-auto contact-us-banner h-full ps-4  border-l border-l-gray-300 ">
    <div class="h-full flex flex-col items-center justify-center" >
      <h1 class="title-heading" data-sal="slide-up" data-sal-duration ='500' data-sal-delay="300">Contact us</h1>
      <p class="text-orange-500 mt-3 font-medium"  data-sal="slide-down" data-sal-duration ='500' data-sal-delay="400" >any time, anything ask us 24x7!</p>
    </div>
  </div>
</section>
<section class="contact-form-wrapper">
  <div class="container ps-4  border-l border-l-gray-300 ">
    <div class="grid lg:grid-cols-2 gap-4">
      <div class="p-7" >
        <span class="title-tag-line" data-sal="slide-down" data-sal-duration ='500' data-sal-delay="300">Get in Touch</span>
        <h2 class="title-sub mt-3" data-sal="slide-up" data-sal-duration ='500' data-sal-delay="400">with Umbrella Travel</h2>
        <p class="font-normal" data-sal="slide-up" data-sal-duration ='500' data-sal-delay="500">We’re here to make your travel experience seamless and unforgettable. Whether you have questions, need assistance with bookings, or require support for your travel needs, our team is ready to help.</p>
      </div>
      <form action="" class="contact-form -mt-11" >
        <div class="relative mb-3">
          <input type="text" id="hs-floating-input-email" class="peer p-4 block w-full border border-gray-200 rounded-lg text-sm placeholder:text-transparent focus:border-blue-500  disabled:opacity-50 disabled:pointer-events-none
                        focus:pt-6
                        focus:pb-2
                        [&:not(:placeholder-shown)]:pt-6
                        [&:not(:placeholder-shown)]:pb-2
                        autofill:pt-6
                        autofill:pb-2" placeholder="you@email.com">
          <label for="hs-floating-input-email" class="absolute top-0 start-0 p-4 h-full text-sm truncate pointer-events-none transition ease-in-out duration-100 border border-transparent  origin-[0_0]  peer-disabled:pointer-events-none
                          peer-focus:scale-90
                          peer-focus:translate-x-0.5
                          peer-focus:-translate-y-1.5
                          peer-focus:text-gray-500
                          peer-[:not(:placeholder-shown)]:scale-90
                          peer-[:not(:placeholder-shown)]:translate-x-0.5
                          peer-[:not(:placeholder-shown)]:-translate-y-1.5
                          peer-[:not(:placeholder-shown)]:text-gray-500 ">Name</label>
        </div>
        <div class="relative mb-3">
          <input type="email" id="hs-floating-input-email" class="peer p-4 block w-full border border-gray-200 rounded-lg text-sm placeholder:text-transparent focus:border-blue-500  disabled:opacity-50 disabled:pointer-events-none
                        focus:pt-6
                        focus:pb-2
                        [&:not(:placeholder-shown)]:pt-6
                        [&:not(:placeholder-shown)]:pb-2
                        autofill:pt-6
                        autofill:pb-2" placeholder="you@email.com">
          <label for="hs-floating-input-email" class="absolute top-0 start-0 p-4 h-full text-sm truncate pointer-events-none transition ease-in-out duration-100 border border-transparent  origin-[0_0]  peer-disabled:pointer-events-none
                          peer-focus:scale-90
                          peer-focus:translate-x-0.5
                          peer-focus:-translate-y-1.5
                          peer-focus:text-gray-500
                          peer-[:not(:placeholder-shown)]:scale-90
                          peer-[:not(:placeholder-shown)]:translate-x-0.5
                          peer-[:not(:placeholder-shown)]:-translate-y-1.5
                          peer-[:not(:placeholder-shown)]:text-gray-500 ">Email</label>
        </div>
        <div class="relative mb-3">
          <input type="text" id="hs-floating-input-email" class="peer p-4 block w-full border border-gray-200 rounded-lg text-sm placeholder:text-transparent focus:border-blue-500  disabled:opacity-50 disabled:pointer-events-none
                        focus:pt-6
                        focus:pb-2
                        [&:not(:placeholder-shown)]:pt-6
                        [&:not(:placeholder-shown)]:pb-2
                        autofill:pt-6
                        autofill:pb-2" placeholder="you@email.com">
          <label for="hs-floating-input-email" class="absolute top-0 start-0 p-4 h-full text-sm truncate pointer-events-none transition ease-in-out duration-100 border border-transparent  origin-[0_0]  peer-disabled:pointer-events-none
                          peer-focus:scale-90
                          peer-focus:translate-x-0.5
                          peer-focus:-translate-y-1.5
                          peer-focus:text-gray-500
                          peer-[:not(:placeholder-shown)]:scale-90
                          peer-[:not(:placeholder-shown)]:translate-x-0.5
                          peer-[:not(:placeholder-shown)]:-translate-y-1.5
                          peer-[:not(:placeholder-shown)]:text-gray-500 ">Subject</label>
        </div>
        <div class="relative mb-3">
                        <textarea id="hs-floating-textarea" class="peer resize-none p-4 block w-full border border-gray-200 rounded-lg text-sm placeholder:text-transparent focus:border-blue-500 focus:ring-blue-500 disabled:opacity-50 disabled:pointer-events-none
                        focus:pt-6
                        focus:pb-2
                        [&:not(:placeholder-shown)]:pt-6
                        [&:not(:placeholder-shown)]:pb-2
                        autofill:pt-6
                        autofill:pb-2" placeholder="This is a textarea placeholder" rows="4"></textarea>
          <label for="hs-floating-textarea" class="absolute top-0 start-0 p-4 h-full text-sm truncate pointer-events-none transition ease-in-out duration-100 border border-transparent origin-[0_0]  peer-disabled:opacity-50 peer-disabled:pointer-events-none
                          peer-focus:text-xs
                          peer-focus:-translate-y-1.5
                          peer-focus:text-gray-500
                          peer-[:not(:placeholder-shown)]:text-xs
                          peer-[:not(:placeholder-shown)]:-translate-y-1.5
                          peer-[:not(:placeholder-shown)]:text-gray-500 ">Comment</label>
        </div>
        <button class="butn butn-orange mt-6">Send <span class="ms-3 icon-arrow-right-long"></span></button>
      </form>
    </div>
  </div>
</section>
